/* import { AppMenuDto } from './app.model';

import { mappingMenus } from './menu.mappings.register';
import { reportMenus } from './menu.reports.register';
import { transactionMenus } from './menu.transactions.register';
import { masterMenus, adminMenu } from './menu.master.register';

import { RoutesService, eLayoutType, TreeNode, ABP } from '@abp/ng.core';
import { LocalizationService } from '@abp/ng.core';
import { systemMenus } from './menu.system.register';
import { integrationMenus } from './menu.integrations.register';

// App Global State
export const appMenus = [
  ...masterMenus,
  ...mappingMenus,
  ...transactionMenus,
  ...systemMenus,
  ...reportMenus,
  ...integrationMenus,
] as AppMenuDto[];

export let menus: TreeNode<ABP.Route>[];
export let visibleMenus: AppMenuDto[];

export const renderMenu = (routes: RoutesService, localizationService: LocalizationService) => {
  const mapMenuItems = (appMenuDtos: AppMenuDto[], module: string, parentName: string) => {
    const newAppMenuDtos = [] as AppMenuDto[];
    appMenuDtos.forEach((menu, index) => {
      const appMenu = {
        path: `/${menu.module || module}/` + menu.path,
        name: '::Menu:' + menu.path,
        parentName: parentName,
        requiredPolicy: menu.requiredPolicy,
        invisible: menu.invisible,
        iconClass: menu.iconClass,
      };
      (appMenu as any).order = index;
      newAppMenuDtos.push(appMenu);
    });
    return newAppMenuDtos;
  };

  const items = [
    ...mapMenuItems(masterMenus, 'x/pg', '::Menu:masterpages'),
    ...mapMenuItems(adminMenu, 'admin', '::Menu:admin'),
    ...mapMenuItems(mappingMenus, 'pages', '::Menu:mappings'),
    ...mapMenuItems(transactionMenus, 'pages', '::Menu:transactions'),
    ...mapMenuItems(systemMenus, 'system', '::Menu:system'),
    ...mapMenuItems(reportMenus, 'reports', '::Menu:reports'),
    ...mapMenuItems(integrationMenus, 'integrations', '::Menu:integrations'),
  ];

  const menuItems = items.map(menu => ({
    path: menu.path,
    name: menu.name,
    iconClass: menu.iconClass,
    parentName: menu.parentName,
    requiredPolicy: menu.requiredPolicy || 'AccessDenied',
    layout: eLayoutType.application,
    invisible: menu.invisible,
    order: (menu as any).order,
  }));
  routes.add(menuItems);

  visibleMenus = [];
  const buildMenu = (children: TreeNode<ABP.Route>[], level = 1) => {
    const treeNodes = [] as TreeNode<ABP.Route>[];
    children.forEach(item => {
      item.invisible = !item.isLeaf && item.children.length <= 0;
      if (item.invisible) return;
      const treeNode = {
        name: localizationService.instant(item.name),
        path: item.path,
        iconClass: item.iconClass || 'right-circle',
        order: item.order,
      } as TreeNode<ABP.Route>;
      (treeNode as any).level = item.parentName ? 2 : 1;
      if (item.children.length > 0) {
        const treeChildren = buildMenu(item.children);
        treeNode.children = treeChildren.sort((a, b) => {
          return a.name < b.name ? -1 : 0;
        });
      }
      treeNodes.push(treeNode);
      if (treeNode.children == null) {
        visibleMenus.push({
          name: item.name,
          path: item.path,
          iconClass: item.iconClass,
        } as AppMenuDto);
      }
    });
    return treeNodes;
  };
  menus = buildMenu(routes.visible);
};

export const clearRenderedMenu = () => {
  menus = null;
};

export const addToVisited = (path: string) => {
  setTimeout(() => {
    const menuVisitedStr = localStorage.getItem('menuVisited');
    const menuVisited = menuVisitedStr ? (JSON.parse(menuVisitedStr) as any[]) : [];
    if (menuVisited.find(m => m.path === path)) {
      menuVisited.forEach(f => {
        if (f.path === path) {
          f.tick = new Date().getTime();
        }
      });
    } else {
      menuVisited.push({ path: path, tick: new Date().getTime() });
      if (menuVisited.length > 10) menuVisited.shift();
    }
    localStorage.setItem('menuVisited', JSON.stringify(menuVisited));
  }, 500);
};
 */

import { AppMenuDto } from './app.model';

import { mappingMenus } from './menu.mappings.register';
import { reportMenus } from './menu.reports.register';
import { transactionMenus } from './menu.transactions.register';
import { masterMenus, adminMenu } from './menu.master.register';

import { RoutesService, eLayoutType, TreeNode, ABP } from '@abp/ng.core';
import { LocalizationService } from '@abp/ng.core';
import { systemMenus } from './menu.system.register';
import { integrationMenus } from './menu.integrations.register';import { customerMenus } from './menu.customer.register';
;

/**
 * ---------------------------------------------------------------------
 * Global Menu State
 * ---------------------------------------------------------------------
 */

// Flat app menu definitions
export const appMenus = [
  ...masterMenus,
  ...mappingMenus,
  ...transactionMenus,
  ...systemMenus,
  ...reportMenus,
  ...integrationMenus,
  ...customerMenus,
] as AppMenuDto[];

// Rendered menu tree (used by sider)
export let menus: TreeNode<ABP.Route>[] = [];

// Flat visible menus (used by search)
export let visibleMenus: AppMenuDto[] = [];

/**
 * ---------------------------------------------------------------------
 * Menu Rendering
 * ---------------------------------------------------------------------
 */

export const renderMenu = (routes: RoutesService, localizationService: LocalizationService) => {
  // 🔐 Always reset state (Angular 18 renders eagerly)
  menus = [];
  visibleMenus = [];

  const hasTenantContext = !!localStorage.getItem('tenantId');
  const shouldHideMenu = (menu: AppMenuDto) => menu.invisible || (menu.hostOnly && hasTenantContext);

  /**
   * Map AppMenuDto -> ABP Route items
   */
  const mapMenuItems = (appMenuDtos: AppMenuDto[], module: string, parentName: string) => {
    return appMenuDtos.map((menu, index) => {
      const mapped = {
        path: `/${menu.module || module}/${menu.path}`,
        name: menu.name || `::Menu:${menu.path}`,
        parentName: menu.parentName || parentName,
        requiredPolicy: menu.requiredPolicy,
        invisible: shouldHideMenu(menu),
        iconClass: menu.iconClass,
        order: index,
      };
      return mapped;
    });
  };

  /**
   * Register routes with ABP
   */
  const items = [
    ...mapMenuItems(masterMenus, 'x/pg', '::Menu:masterpages'),
    ...mapMenuItems(adminMenu, 'admin', '::Menu:admin'),
    ...mapMenuItems(mappingMenus, 'pages', '::Menu:mappings'),
    ...mapMenuItems(transactionMenus, 'pages', '::Menu:transactions'),
    ...mapMenuItems(systemMenus, 'system', '::Menu:system'),
    ...mapMenuItems(reportMenus, 'reports', '::Menu:reports'),
    ...mapMenuItems(integrationMenus, 'integrations', '::Menu:integrations'),
    ...mapMenuItems(customerMenus, 'pages', '::Menu:customers'),
  ];

  const routeItems = items.map(menu => ({
    path: menu.path,
    name: menu.name,
    iconClass: menu.iconClass,
    parentName: menu.parentName,
    requiredPolicy: menu.requiredPolicy || 'AccessDenied',
    layout: eLayoutType.application,
    invisible: menu.invisible,
    order: menu.order,
  }));

  routes.add(routeItems);

  /**
   * Build hierarchical menu tree
   */
  const buildMenu = (children: TreeNode<ABP.Route>[], level = 1) => {
    const treeNodes: TreeNode<ABP.Route>[] = [];

    children.forEach(item => {
      // ❌ Skip invalid or unnamed routes
      if (!item || !item.name) return;

      // Hide empty parent/group routes. They only become visible when a permitted child is present.
      item.invisible =
        (!item.isLeaf && (!item.children || item.children.length === 0)) ||
        (item.isLeaf && !item.path);
      if (item.invisible) return;

      const localizedName = localizationService.instant(item.name);

      const treeNode = {
        name: localizedName,
        path: item.path,
        iconClass: item.iconClass || 'right-circle',
        order: item.order,
        level,
      } as unknown as TreeNode<ABP.Route>;

      // Recursively build children
      if (item.children?.length) {
        const treeChildren = buildMenu(item.children, level + 1);
        if (treeChildren.length) {
          treeNode.children = treeChildren.sort((a, b) => a.name.localeCompare(b.name));
        }
      }

      treeNodes.push(treeNode);

      // Add leaf nodes to search list
      if (!treeNode.children && treeNode.path) {
        visibleMenus.push({
          name: localizedName,
          path: treeNode.path,
          iconClass: treeNode.iconClass,
        } as AppMenuDto);
      }
    });

    return treeNodes;
  };

  menus = buildMenu(routes.visible);
};

/**
 * ---------------------------------------------------------------------
 * Utilities
 * ---------------------------------------------------------------------
 */

export const clearRenderedMenu = () => {
  menus = [];
  visibleMenus = [];
};

export const addToVisited = (path: string) => {
  setTimeout(() => {
    const menuVisitedStr = localStorage.getItem('menuVisited');
    const menuVisited = menuVisitedStr ? (JSON.parse(menuVisitedStr) as any[]) : [];

    const existing = menuVisited.find(m => m.path === path);
    if (existing) {
      existing.tick = Date.now();
    } else {
      menuVisited.push({ path, tick: Date.now() });
      if (menuVisited.length > 10) {
        menuVisited.shift();
      }
    }

    localStorage.setItem('menuVisited', JSON.stringify(menuVisited));
  }, 500);
};
